export default __webpack_public_path__ + "6c494d5717d18a21fb8d712559b553fe.gif";